export default __webpack_public_path__ + "static/media/logo1.89576664.png";